module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src023959432/src/github.com/GipsyBot/gipsy-webapp/node_modules/babel-runtime/core-js/promise.js
// module id = 125
// module chunks = 0